export default "__VITE_ASSET__BvWKpoc7__"